/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState } from 'react';

import {
  TextWithHrefsAndModalsDisplayPart as ConsumerDisplayPart,
  CheckboxWithDisplayProps as ConsumerDisplayProps,
} from '@blend/consumer-components';

import { getTextScreenDefinition } from '../../ContextualHelpList/contextualHelpUtils';
import { DisplayPart } from '../types';
import { CheckboxWithDisplay } from '@components/form/Inputs/CheckboxWithDisplay/CheckboxWithDisplay';
import { ContextualHelpListItemModal } from '@components/form/ContextualHelpList/ContextualHelpListItemModal';
import { map, compact } from '@utils/lodash';

namespace GenericRequiredCheckbox {
  export interface State {
    activeModal: string | null;
  }

  export interface Props
    extends React.InputHTMLAttributes<HTMLInputElement>,
      Omit<ConsumerDisplayProps, 'displayParts' | 'color'> {
    id: string;
    displayParts: DisplayPart[];
  }
}
export const GenericRequiredCheckbox: React.FC<GenericRequiredCheckbox.Props> = ({
  id,
  displayParts,
  ...otherProps
}) => {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const getFormattedDisplayParts = () => {
    return map(displayParts, (displayPart): ConsumerDisplayPart => {
      if (typeof displayPart === 'string') {
        return displayPart;
      }
      const textScreenDefinition = getTextScreenDefinition(displayPart.textScreenId);
      return {
        display: textScreenDefinition.linkText,
        onClick: () => setActiveModal(displayPart.textScreenId),
      };
    });
  };

  const renderContextualHelpModals = () => {
    return compact(
      displayParts.map((displayPart, idx) => {
        if (typeof displayPart === 'string') {
          return null;
        }
        const textScreenDefinition = getTextScreenDefinition(displayPart.textScreenId);
        return (
          <ContextualHelpListItemModal
            key={idx}
            contentLabel={textScreenDefinition.title}
            handleClose={() => setActiveModal(null)}
            headerText={textScreenDefinition.title}
            isOpen={activeModal === displayPart.textScreenId}
            textScreenId={displayPart.textScreenId}
            textScreenDefinition={textScreenDefinition}
          />
        );
      }),
    );
  };

  return (
    <>
      <CheckboxWithDisplay {...otherProps} id={id} displayParts={getFormattedDisplayParts()} />
      {renderContextualHelpModals()}
    </>
  );
};
